import React from "react";
import { Link, LinkProps } from "@mui/material";
import { useHistory } from "react-router-dom";
import { styled } from "@mui/material/styles";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import GroupIcon from "@mui/icons-material/Group";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import "./AppFooter.scss";

const NavItem = styled(Link)<LinkProps>(() => ({
    padding: "1rem",
    color: "#b9b8b8",
    textDecoration: "none",
    borderRadius: "4px",
    display: "block",

    "@media (max-width: 898px)": {
        padding: "0.5rem",
        fontSize: "0.7rem",
    },

    "&:hover": {
        color: "#e6117b",
    },
}));

const AppFooter: React.FC = () => {
    const history = useHistory();

    const links = [
        {
            url: "new-setup",
            label: "New Setup",
            icon: AddCircleIcon,
        },
        {
            url: "/",
            label: "My Setups",
            icon: FormatListBulletedIcon,
        },
        {
            url: "category",
            label: "Community Setups",
            icon: GroupIcon,
        },
        {
            url: "import",
            label: "Import Setup",
            icon: CloudUploadIcon,
        },
    ];

    return (
        <footer className="nav">
            <ul>
                {links.map((link) => {
                    const Icon = link.icon;

                    return (
                        <li key={link.url}>
                            <NavItem
                                color="inherit"
                                onClick={() => history.push(link.url)}
                                sx={{ cursor: "pointer" }}
                            >
                                <div>
                                    <Icon sx={{ marginRight: "0.5rem" }} />
                                </div>

                                {link.label}
                            </NavItem>
                        </li>
                    );
                })}
            </ul>
        </footer>
    );
};

export default AppFooter;
